import { company } from '~/company/Company';
import { getCloudflareUrl } from '~/components/CloudflareResponsiveImage/utils';

export const createCategoryUrl = ({ id }: { id: number | string }) =>
  `/c/${id}`;
export const createProductUrl = ({ id }: { id: number | string }) => `/p/${id}`;

export const cfSrcForImage = (
  src: string,
  size: { width: number; height: number },
) =>
  getCloudflareUrl(
    src,
    company.envVariables.REACT_APP_CLOUDFLARE_IMAGE_RESIZE_DOMAIN,
    size,
  );
